import PropTypes from 'prop-types';
import React from 'react';
import { Row, Col, Well } from 'react-bootstrap';
import { Link } from 'react-router';
import TableauViz from './TableauViz.react';
import { View } from '../stores/ReportStore';
import { OrganizationPropTypes } from '../util/helpers/SharedPropTypes';
import { getCrossChannelTableauForOrganization } from '../pages/crosschannel/config/tableauOrganizationMapping';

function buildView(organization) {
  const workbookName = getCrossChannelTableauForOrganization(organization);
  const view = new View({
    default: false,
    id: 0,
    index: 0,
    name: 'View',
    viewPath: `${workbookName}/CrossChannelAnalysis`,
  });
  return view;
}

function tableauLink(organization, tableauReportKey) {
  const workbookName = getCrossChannelTableauForOrganization(organization);
  return `/tableau/${workbookName}/CrossChannelAnalysis?run_name=${tableauReportKey}`;
}

const wellStyling = {
  background: '#eaf4fb',
  marginTop: '10px',
};

const ScenarioViewTableauReport = ({ tableauReportKey, organization }) => (
  <Row className='scenario-tableau-report'>
    <Col sm={12}>
      <div className='scenario-tableau-content'>
        <TableauViz
          view={buildView(organization)}
          tableauOptions={{
            run_name: tableauReportKey,
          }}
        />
      </div>
    </Col>

    <Col sm={4} className='scenario-tableau-report-link'>
      <Well bsSize='large' style={wellStyling} className='text-center'>
        <strong>This is a summary.</strong><br />
        <Link to={tableauLink(organization, tableauReportKey)}>
          <strong>Click here</strong>{ ' ' }
        </Link>
        to view the full report.
      </Well>
    </Col>
  </Row>
);

ScenarioViewTableauReport.propTypes = {
  tableauReportKey: PropTypes.string,
  organization: OrganizationPropTypes,
};

export default ScenarioViewTableauReport;
